import { Component, OnInit } from '@angular/core';
import { BaryModalEvent, IBaryModalEvent } from '../../../../models/bary-modal-event';
import { BaryComponentHelper } from '../../../shared/util/bary-component-helper';
import { MDBModalRef } from 'ng-uikit-pro-standard';
import { TransportFormGroup } from '../../../../models/forms/TransportFormGroup';

@Component({
  selector: 'jhi-modal-use-registered-address',
  templateUrl: './modal-use-registered-address.component.html',
  styleUrls: ['./modal-use-registered-address.component.scss'],
})
export class ModalUseRegisteredAddressComponent implements OnInit {
  transportForm!: TransportFormGroup;
  isPickup!: boolean;
  isLightEstimate = false;
  action = BaryComponentHelper.generateAction<IBaryModalEvent>();
  loaded = false;
  title: string | undefined;
  icon = 'city';
  iconClass = 'text-info';

  constructor(private modalRef: MDBModalRef) {}

  handleClick(from: any): void {
    this.action.next(new BaryModalEvent(from));
    this.modalRef.hide();
  }

  ngOnInit(): void {
    this.loaded = true;
  }

  submit(): void {
    this.action.next(new BaryModalEvent({ submit: true }));
    this.modalRef.hide();
  }
}
